import React from 'react'
import Loader from '../Loader'

export default function SuspenseFallback(): JSX.Element {
  return <Loader loading />
}
